const NotFoundPage = () => {
  return <div>404Page</div>;
};

export default NotFoundPage;
